import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';

@observer
export class StaticHtmlView extends React.Component<{ html: string }> {
  constructor(props: { html: string }) {
    super(props);
    makeObservable(this);
  }

  @computed
  get dangerousInnerHtml(): { __html: string } {
    return {__html: this.props.html};
  }

  render() {
    return <div className="static-html-wrapper"
                dangerouslySetInnerHTML={this.dangerousInnerHtml}/>;
  }
}
